export const createCondicaoPagamentoModel = ({
  id_condicao_pagamento = '',
  condicao_pagamento = '',
  parcelas = []
} = {}) => ({
  id_condicao_pagamento,
  condicao_pagamento,
  parcelas
});